/**
 *  『商品情報』画面に引き渡す値を格納するVO
 *
 * @export KYMW1406OutputModel
 * @class KYMW1406OutputModel
 */
export class KYMW1406OutputModel {
  /**
   * コマＩＤ
   */
  public komaID = Number(0);

  /**
   * 更新フラグ
   * 0:デフォルト、1:更新、2:削除、3:商品情報変更
   */
  public updateFlg = Number(0);

  /**
   * 注文商品区分
   * 01:通常注文商品　02：いつでも注文商品
   */
  public orderGoodsFlg = String('');
}
